module.exports = __webpack_public_path__ + "img/Slack.06e94d69.svg";